import { HStack, VStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";

import { PhoneNumberController } from "./controller";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";

export const PhoneNumber = () => {
  const { control, back, handleOnSubmitForm, isSubmitting } =
    PhoneNumberController();

  return (
    <PageScaffold
      onBackPress={back}
      onPressRightIcon={back}
      rightWebLabel="Fechar"
      title="Celular"
      footerContent={
        <ScaffoldFooter
          primaryText="Continuar"
          primaryAction="primary"
          primaryIsLoading={isSubmitting}
          primaryIsDisabled={isSubmitting}
          primaryOnPress={handleOnSubmitForm}
          secondaryIsDisabled={isSubmitting}
          secondaryText="Cancelar"
          secondaryOnPress={back}
        />
      }
    >
      <HStack mb="$6">
        <Text fontSize="$md" fontWeight={500} color="$textLight800">
          Informe o DDD e o número do celular:
        </Text>
      </HStack>

      <VStack w="$full" gap="$4">
        <InputControlled
          control={control}
          size="md"
          name="cellPhone"
          mask="cellphone"
          keyboardType="number-pad"
          placeholder="Digite o DDD e o número do celular"
          label="DDD e Celular"
          returnKeyType="done"
          isRequired
        />
      </VStack>
    </PageScaffold>
  );
};
